import type { YachtAction, YachtGameState } from "../types";
import { applyRollDice } from "./roll-dice";
import { applyScoreCategory } from "./score-category";
import { applyToggleHold } from "./toggle-hold";

export { applyRollDice } from "./roll-dice";
export { applyScoreCategory } from "./score-category";
export { applyToggleHold } from "./toggle-hold";

export function applyAction(
  state: YachtGameState,
  action: YachtAction,
): YachtGameState {
  switch (action.type) {
    case "ROLL_DICE":
      return applyRollDice(state, action);
    case "TOGGLE_HOLD":
      return applyToggleHold(state, action);
    case "SCORE_CATEGORY":
      return applyScoreCategory(state, action);
    default:
      return state;
  }
}
